module.exports = __webpack_public_path__ + "static/media/letter_7@3x.7e225934.png";


//////////////////
// WEBPACK FOOTER
// ./src/icons/letter_7@3x.png
// module id = 597
// module chunks = 0